import React from 'react'
import { SelectedIcon as ISelectedIcon } from "@ecountabl/lib"
import { IconProps } from 'react-native-vector-icons/Icon'

import { AntDesign } from "@expo/vector-icons"
import { Entypo } from "@expo/vector-icons"
import { EvilIcons } from "@expo/vector-icons"
import { Feather } from "@expo/vector-icons"
import { FontAwesome } from "@expo/vector-icons"
import { FontAwesome5 } from "@expo/vector-icons"
import { Fontisto } from "@expo/vector-icons"
import { Foundation } from "@expo/vector-icons"
import { Ionicons } from '@expo/vector-icons'
import { MaterialCommunityIcons } from "@expo/vector-icons"
import { MaterialIcons } from "@expo/vector-icons"
import { Octicons } from "@expo/vector-icons"
import { SimpleLineIcons } from "@expo/vector-icons"
import { Zocial } from "@expo/vector-icons"

const fonts = {
  AntDesign,
  Entypo,
  EvilIcons,
  Feather,
  FontAwesome,
  FontAwesome5,
  Fontisto,
  Foundation,
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  Octicons,
  SimpleLineIcons,
  Zocial
}

type Props = {
  icon: ISelectedIcon
} & Omit<IconProps, "name">

export const SelectedIcon = ({ icon, ...props }: Props): React.ReactElement => {
  if (!icon?.family) {
    return null
  }

  const Font = fonts[icon.family]
  
  return <Font name={icon.name} {...props} />
}

export default SelectedIcon